import { bindActionCreators } from 'redux';

export const CREATE_ADMIN_USER = 'LOGINADMIN/CREATE_ADMIN_USER';
export const LOGOUT_ADMIN_USER = 'LOGINADMIN/LOGOUT_ADMIN_USER';
export const CHECK_AUTHORIZATION = 'LOGINADMIN/CHECK_AUTHORIZATION';
export const GET_CARS_LIST_EDITOR = 'LOGINADMIN/GET_CARS_LIST_EDITOR';
export const LOAD_CAR_LIST = 'LOGINADMIN/LOAD_CAR_LIST';
export const ADD_CAR_CHANGE_DATA = 'LOGINADMIN/ADD_CAR_CHANGE_DATA';
export const ADD_CAR_DATA_PAGE = 'LOGINADMIN/ADD_CAR_DATA_PAGE';
export const SET_ACTION_PAGE = 'LOGINADMIN/SET_ACTION_PAGE';
export const UPLOAD_IMG_CAR = 'LOGINADMIN/UPLOAD_IMG_CAR';
export const ADD_IMG_CAR_DATA = 'LOGINADMIN/ADD_IMG_CAR_DATA';
export const EDIT_ADD_IMG_CAR_DATA = 'LOGINADMIN/EDIT_ADD_IMG_CAR_DATA';
export const EDIT_UPLOAD_IMG_CAR = 'LOGINADMIN/EDIT_UPLOAD_IMG_CAR';
export const DEL_IMG_CAR_DATA = 'LOGINADMIN/DEL_IMG_CAR_DATA';
export const EDIT_DEL_IMG_CAR_DATA = 'LOGINADMIN/EDIT_DEL_IMG_CAR_DATA';
export const ADD_NEW_CAR = 'LOGINADMIN/ADD_NEW_CAR';
export const DELETE_CARS = 'LOGINADMIN/DELETE_CARS';
export const LOAD_CAR_DARA_TO_CARDATAPAGE = 'LOGINADMIN/LOAD_CAR_DARA_TO_CARDATAPAGE';
export const EDIT_CAR_REQ = 'LOGINADMIN/EDIT_CAR_REQ';

export const SET_MENU_PAGE = 'LOGINADMIN/SET_MENU_PAGE';
export const SET_SUB_MENU_PAGE = 'LOGINADMIN/SET_SUB_MENU_PAGE';

export const loadCarData = carData => ({
  type: LOAD_CAR_DARA_TO_CARDATAPAGE,
  payload: carData
});

export const setSubMenu = pageName => ({
  type: SET_SUB_MENU_PAGE,
  payload: pageName
});

export const setMenuPage = pageName => ({
  type: SET_MENU_PAGE,
  payload: pageName
});

export const EditDelImgUrlToCarData = url => ({
  type: EDIT_DEL_IMG_CAR_DATA,
  payload: url
});

export const EditAddImgUrlToCarData = url => ({
  type: EDIT_ADD_IMG_CAR_DATA,
  payload: url
});

export const EditUploadImgCar = file => ({
  type: EDIT_UPLOAD_IMG_CAR,
  payload: file
});

export const DelImgUrlToCarData = url => ({
  type: DEL_IMG_CAR_DATA,
  payload: url
});

export const AddImgUrlToCarData = url => ({
  type: ADD_IMG_CAR_DATA,
  payload: url
});

export const deleteCars = arrayOfCars => ({
  type: DELETE_CARS,
  payload: arrayOfCars
});

export const EditCarReq = data => ({
  type: EDIT_CAR_REQ,
  payload: data
});

export const AddNewCar = data => ({
  type: ADD_NEW_CAR,
  payload: data
});

export const createAdminUser = user => ({
  type: CREATE_ADMIN_USER,
  payload: user
});

export const uploadImgCar = file => ({
  type: UPLOAD_IMG_CAR,
  payload: file
});

export const SetActionPage = pageName => ({
  type: SET_ACTION_PAGE,
  payload: pageName
});

export const ChangeAddCarDataPage = pageNumber => ({
  type: ADD_CAR_DATA_PAGE,
  payload: pageNumber
});
export const AddCarChangeData = AddcarData => ({
  type: ADD_CAR_CHANGE_DATA,
  payload: AddcarData
});
export const loadCarList = carlist => ({
  type: LOAD_CAR_LIST,
  payload: carlist
});
export const logoutAdmin = () => ({
  type: LOGOUT_ADMIN_USER
});

export const checkAuthorization = () => ({
  type: CHECK_AUTHORIZATION
});
export const getCarsList = () => ({
  type: GET_CARS_LIST_EDITOR
});

function containerActions(dispatch) {
  return bindActionCreators(
    {
      createAdminUser,
      logoutAdmin,
      checkAuthorization,
      getCarsList,
      loadCarList,
      AddCarChangeData,
      ChangeAddCarDataPage,
      SetActionPage,
      uploadImgCar,
      AddImgUrlToCarData,
      DelImgUrlToCarData,
      AddNewCar,
      deleteCars,
      setMenuPage,
      setSubMenu,
      loadCarData,
      EditDelImgUrlToCarData,
      EditAddImgUrlToCarData,
      EditUploadImgCar,
      EditCarReq
    },
    dispatch
  );
}

export default containerActions;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/actions.js